module.exports = __webpack_public_path__ + "media/images/voices/bg-mv-sm-c66a7a3c0725c98bcdbc4ea4e22fd5bf.jpg";